// MODARIA — Compliance / regulator constants.
// Single source of truth shared by ComplianceShield and RegulatorBanner.

// EU AI Act Reg. (EU) 2024/1689 — Article 50 enforcement date.
export const ENFORCEMENT_DATE = new Date('2026-08-02T00:00:00Z');

// Penalty cap per AI Act art. 99: €35M or 7% of global annual turnover.
export const PENALTY_AMOUNT_EUR = 35_000_000;
export const PENALTY_TURNOVER_PCT = 7;

// localStorage key — versioned so we can re-show the banner if we ever change copy.
export const BANNER_DISMISSED_KEY = 'modaria-regulator-banner-dismissed-v1';

// External AI Act art. 50 reference.
export const AI_ACT_ART_50_URL = 'https://artificialintelligenceact.eu/article/50/';
